import { render } from "./SupplierSpecificQuote.vue?vue&type=template&id=8b3ac09c&scoped=true"
import script from "./SupplierSpecificQuote.vue?vue&type=script&lang=js"
export * from "./SupplierSpecificQuote.vue?vue&type=script&lang=js"

import "./SupplierSpecificQuote.vue?vue&type=style&index=0&id=8b3ac09c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3ac09c"]])

export default __exports__